import { aboutStats, brand, contactEmail, principles, reviews } from "@/mocks/home";

export default function About() {
  return (
    <section id="about" className="scroll-mt-24 bg-[#f4ecdf]">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs font-semibold tracking-widest text-[#c2410c] mb-2 flex items-center justify-center gap-2">
            <i className="ri-flag-2-line"></i> ABOUT US
          </div>
          <h2 className="font-display text-2xl md:text-4xl font-bold text-[#241c15]">
            关于{brand.name}
          </h2>
          <p className="mt-4 text-[15px] leading-7 text-[#6b5d4d]">
            我们是一群把「把每件事讲透」当底线的内容编辑。在信息又碎又快的时代，选择慢下来——
            用时间线还原过程，用信源标注建立信任，用公开更正对抗谣言。
          </p>
        </div>

        {/* stats band */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
          {aboutStats.map((s, i) => (
            <div
              key={s.label}
              className={`bg-white rounded-xl border border-[#e5d2ba] p-5 text-center ${
                i === 1 ? "bg-[#c2410c] border-[#c2410c]" : ""
              }`}
            >
              <div
                className={`font-number text-4xl leading-none ${
                  i === 1 ? "text-white" : "text-[#c2410c]"
                }`}
              >
                {s.num}
              </div>
              <div
                className={`text-sm font-medium mt-2 ${i === 1 ? "text-white/90" : "text-[#3a2f24]"}`}
              >
                {s.label}
              </div>
            </div>
          ))}
        </div>

        {/* principles + reviews */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-10">
          <div className="bg-white rounded-2xl border border-[#e5d2ba] p-6">
            <h3 className="text-base font-semibold text-[#241c15] flex items-center gap-2">
              <i className="ri-git-merge-line text-[#c2410c]"></i>
              我们坚持的三件事
            </h3>
            <ul className="mt-4 space-y-4">
              {principles.map((p) => (
                <li key={p.title} className="flex gap-3.5">
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-[#fde8d7] text-[#c2410c]">
                    <i className={`${p.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h4 className="text-[15px] font-semibold text-[#3a2f24]">{p.title}</h4>
                    <p className="text-[13px] leading-6 text-[#7a6a58] mt-0.5">{p.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-[#e5d2ba] bg-[#fffaf2] p-6">
            <h3 className="text-base font-semibold text-[#241c15] flex items-center gap-2 mb-4">
              <i className="ri-chat-heart-line text-[#c2410c]"></i>
              读者怎么看
            </h3>
            <div className="space-y-4">
              {reviews.map((r, i) => (
                <figure key={i} className="bg-white rounded-xl border border-[#f0e0ca] p-4">
                  <i className="ri-double-quotes-l text-2xl text-[#e3b98c]"></i>
                  <blockquote className="text-[14px] leading-6 text-[#5b4f45] mt-1">
                    {r.quote}
                  </blockquote>
                  <figcaption className="text-[12px] text-[#a08b73] mt-2">
                    — {r.who}
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>

        {/* contact strip */}
        <div className="mt-10 bg-[#201a14] rounded-2xl p-6 md:p-8 text-[#f4e9dc] grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          <div>
            <h3 className="font-display text-xl font-bold text-[#ffe9d6] flex items-center gap-2">
              <i className="ri-hand-heart-line text-orange-400"></i>
              有线索想投稿？
            </h3>
            <p className="text-sm leading-6 text-[#c9b49c] mt-2">
              提供公开链接或可匿名处理的原始材料即可。核实前我们不会直接引用你的来料，立场（当事方 / 亲历者 / 旁观者）请一并说明。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 md:justify-end">
            <span className="inline-flex items-center gap-2 text-sm text-[#ffe9d6] bg-[#2b231b] rounded-md px-4 py-3 whitespace-nowrap">
              <i className="ri-mail-fill text-orange-400"></i>
              {contactEmail}
            </span>
            <a
              href="#about"
              className="text-sm font-semibold text-[#201a14] bg-orange-400 rounded-md px-4 py-3 whitespace-nowrap hover:bg-orange-300 transition-colors cursor-pointer"
            >
              前往订阅
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}